import type PointStyleSettingsModule from "./pointStyleSettingsModule";

export default class TerritoryPointStyleSettingsModule {
    private pointStyleSettings: PointStyleSettingsModule;

    constructor(pointStyleSettings: PointStyleSettingsModule) {
        this.pointStyleSettings = pointStyleSettings;
    }

    /**
     * 
     * @param styleSettings 
     * @param territoryModel 
     * 
     * @returns 
     */
    getRequiredAttributes(styleSettings, territoryModel): string[] {
        if (!territoryModel || territoryModel.isAccountOnly()) {
            return this.pointStyleSettings.getRequiredAttributes(styleSettings, territoryModel);
        }

        return [territoryModel.getLinkAttributeName()];
    }
}
